// Small wording helpers shared by the customer list, panel and call sheet.

export const plural = (value, one, many = `${one}s`) => (Number(value) === 1 ? one : many);

export function cadence(days) {
  const value = Number(days);
  if (!value) return "";
  if (value <= 1) return "daily";
  if (value === 7) return "weekly";
  if (value % 7 === 0) return `every ${value / 7} weeks`;
  return `every ${value} days`;
}

export function daysAgo(days) {
  if (days == null) return "";
  const value = Number(days);
  if (value <= 0) return "today";
  if (value === 1) return "yesterday";
  return `${value} days ago`;
}

export function phoneText(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  const local = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  return local.length === 10 ? `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}` : String(phone || "");
}

export const STATUS_TONES = {
  late: "late", switching: "elsewhere", spending_less: "less", ordering_less: "quiet", smaller_orders: "quiet",
};
